module.exports = __webpack_public_path__ + "img/product-preview-6.d4cb538.png";